export default __webpack_public_path__ + "static/media/LAS0180.34I-30559_-17730_0.7f3dcb6f.jpg";